function initializeProductCard() {
  const productCards = document.querySelectorAll(".product-card");

  productCards.forEach((cards) => {
    const productCardDetails = cards.querySelector(".product-card-details");
    if (!productCardDetails) return; // Skip this card if details not found

    const productCardDetailsWrapper = productCardDetails.querySelector(
      ".product-card-details-wrapper"
    );
    if (!productCardDetailsWrapper) return;

    const productCardActions = cards.querySelector(
      ".product-card-actions"
    );
    if (!productCardActions) return;

    const productCardActionButtons = productCardActions.querySelectorAll(
      ".product-card-actions-buttons"
    );

    const productCardPrices = productCardDetailsWrapper.querySelector(
      ".product-card-prices"
    );
    if (!productCardPrices) return;

    const productCardVariants = productCardDetailsWrapper.querySelector(
      ".product-card-variants"
    );
    if (!productCardVariants) return;

    const productCardSwatches = productCardDetailsWrapper.querySelector(
      ".product-card-swatches"
    );
    if (!productCardSwatches) return;

    const productCardVariantsList = productCardVariants.querySelectorAll("li");
    const productCardPriceList = productCardPrices.querySelectorAll("li");

    const productCardSwatchList = productCardSwatches.querySelectorAll(
      "#product-card-swatch"
    );

    const productImages = cards.querySelector(".product-card-images");
    if (!productImages) return;

    const productImageList = productImages.querySelectorAll("img");

    // Only add event listeners if we actually have swatches
    if (productCardSwatchList.length > 0) {
      productCardSwatchList.forEach((swatch) => {
        swatch.addEventListener("click", function (event) {
          event.preventDefault();
          event.stopPropagation();

          // Use currentTarget (the li element) instead of target (which might be a child element)
          const swatchElement = event.currentTarget;
          const { variantId } = swatchElement.dataset;

          if (!variantId) return; // Exit early if no variant ID found

          productCardActions.dataset.variantId = variantId;

          productCardVariantsList.forEach((variant) => {
            const { variantId: variantDisplayId } = variant.dataset;
            variant.style.display =
              variantDisplayId === variantId ? "block" : "none";
          });

          productCardPriceList.forEach((price) => {
            const { variantId: variantPriceId } = price.dataset;
            price.style.display = variantPriceId === variantId ? "block" : "none";
          });

          productImageList.forEach((image) => {
            const { variantId: variantImageId } = image.dataset;
            image.style.display = variantImageId === variantId ? "block" : "none";
          });

          // Update title link for selected variant (after images are updated)
          const titleWrapper = cards.querySelector('.title-wrapper');
          const visibleImage = productImages.querySelector('img[style*="display: block"]');
          if (titleWrapper && visibleImage) {
            const onClickStr = visibleImage.getAttribute('onclick');
            const linkMatch = onClickStr.match(/handleRedirectProductCard\('([^']+)'\)/);
            if (linkMatch) {
              const link = linkMatch[1];
              titleWrapper.setAttribute('onclick', `handleRedirectProductCard('${link}')`);
            }
          }

          productCardSwatchList.forEach((swatchItem) => {
            const { variantId: variantSwatchItem } = swatchItem.dataset;

            if (variantSwatchItem === variantId) {
              swatchItem.classList.add("current-active-swatch");
            } else {
              swatchItem.classList.remove("current-active-swatch");
            }
          });

          productCardActionButtons.forEach((buttons) => {
            const { variantId: variantDisplayId, isAvailable } = buttons.dataset;
            buttons.style.display =
              variantDisplayId === variantId ? "flex" : "none";
            const buttonElements = buttons.querySelectorAll("a");
            if (buttonElements.length >= 2) {
              const [normalButton, waitlistButton] = buttonElements;
              normalButton.style.display = isAvailable === "true" ? "flex" : "none";
              waitlistButton.style.display = isAvailable === "true" ? "none" : "flex";
            }
          });
        });
      });
    }
  });
}

initializeProductCard();

function handleRedirectProductCard(url) {
  window.location = url;
}
